// @flow

import _ from 'lodash';

import GeolocUtils from '../utils/GeolocUtils';

import ApiObject from './ApiObject';
import GeoPt from './GeoPt';
import Restaurant from './Restaurant';

export default class RestaurantsList extends ApiObject {

  restaurants: Array<Restaurant> = [];

  postJsonAssignation(data: Object) {
    super.postJsonAssignation(data);

    // -- deserialize restaurants
    this.restaurants = [];

    // -- handle the case were the api responds a json with the array directly.
    let dataRestaurants = [];
    if (!_.isUndefined(data.restaurants)) {
      dataRestaurants = data.restaurants;
    } else {
      dataRestaurants = data;
    }

    _.each(dataRestaurants, (restaurantData: Object) => {
      const restaurant:Restaurant = new Restaurant();
      restaurant.fromJson(restaurantData);
      this.restaurants.push(restaurant);
    });
  }

  findById(idToFind: string): ?Restaurant {
    const found = _.find(this.restaurants, (restaurant: Restaurant): boolean => {
      return restaurant.id === idToFind;
    });

    if (_.isUndefined(found)) {
      return null;
    }

    return found;
  }

  count() {
    return this.restaurants.length;
  }


  getWithOrderModeAvailable(orderMode: number): Array<Restaurant> {
    const restaurants = [];

    _.each(this.restaurants, (restaurant: Restaurant) => {
      if (!_.isNil(restaurant.orderSettings)) {
        if (restaurant.haveFeatureOrder() && restaurant.orderSettings.isEnabledForMode(orderMode)) {
          restaurants.push(restaurant);
        }
      }
    });

    return restaurants;
  }

  getWithAtLeastOneOrderModeAvailable(): Array<Restaurant> {
    const restaurants = [];

    _.each(this.restaurants, (restaurant: Restaurant) => {
      if (!_.isNil(restaurant.orderSettings)) {
        if (restaurant.haveFeatureOrder()) {
          const delivery: boolean = restaurant.orderSettings.isDeliveryEnabled();
          const onSite: boolean = restaurant.orderSettings.isOnSiteEnabled();
          const takeAway: boolean = restaurant.orderSettings.isDeliveryEnabled();

          if (delivery || onSite || takeAway) {
            restaurants.push(restaurant);
          }
        }
      }
    });

    return restaurants;
  }

  sortByLocation(location: GeoPt): RestaurantsList {
    this.restaurants = _.sortBy(this.restaurants, (restaurant: Restaurant) => {
      return GeolocUtils.getDistanceBetweenPoints(location, restaurant.geoPt);
    });
  }
}
